import { z } from 'zod';

export const AdminLoginResponse = z.object({
  mfaChallengeToken: z.string().min(10),
  mfaEnrolled: z.boolean(),
});
export type AdminLoginResponse = z.infer<typeof AdminLoginResponse>;

export const EnrollResponse = z.object({
  secret: z.string(),
  otpauthUrl: z.string(),
  qrDataUrl: z.string(),
  deviceId: z.string(),
});
export type EnrollResponse = z.infer<typeof EnrollResponse>;

/** #429 — respuesta de la fase 2 del re-enrolamiento. */
export const ConfirmEnrollResponse = z.object({ confirmed: z.literal(true) });
export type ConfirmEnrollResponse = z.infer<typeof ConfirmEnrollResponse>;

/** #429 — respuesta al abandonar un re-enrolamiento en curso. */
export const CancelEnrollResponse = z.object({ cancelled: z.literal(true) });
export type CancelEnrollResponse = z.infer<typeof CancelEnrollResponse>;

export const TokenPairResponse = z.object({
  accessToken: z.string().min(10),
  refreshToken: z.string().min(20),
});
export type TokenPairResponse = z.infer<typeof TokenPairResponse>;

// GET /v1/auth/me — identidad compacta del token para poblar el panel.
// `displayName` puede ser null; `mfa` viene del claim del access token.
export const MeResponse = z.object({
  id: z.string(),
  email: z.string(),
  displayName: z.string().nullable(),
  role: z.string(),
  mfa: z.boolean(),
});
export type MeResponse = z.infer<typeof MeResponse>;
